import { Component, computed, inject, input, signal } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

import type { AggregatedEvaluationsQuestionNote } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { provideFilteredMentions } from '@core/notes-legacy';
import { RenderDirective, WysiwygContext$ } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorDefaultConfig,
  ProsemirrorDefaultConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import {
  AvatarComponent,
  BoxComponent,
  DividerComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-offer-evaluation-question-comments',
  templateUrl: './candidate-offer-evaluation-question-comments.component.html',
  styleUrl: './candidate-offer-evaluation-question-comments.component.less',
  imports: [
    AvatarComponent,
    BoxComponent,
    DividerComponent,
    IconComponent,
    ProsemirrorDefaultConfigDirective,
    RenderDirective,
    TranslatePipe,
  ],
  providers: [
    { provide: WysiwygContext$, useFactory: () => new WysiwygContext$(null) },
    ...provideFilteredMentions(),
  ],
})
export class CandidateOfferEvaluationQuestionCommentsComponent {
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly ProsemirrorConfig = ProsemirrorDefaultConfig;

  public notes = input.required<AggregatedEvaluationsQuestionNote[]>();

  public useProsemirror = input(false);

  protected isExpanded = signal(false);

  protected safeNotes = computed(() =>
    this.notes().map(note => ({
      ...note,
      safeNoteHtml: this.getSafeNoteHtml(note.noteHtml),
    })),
  );

  protected toggle(): void {
    this.isExpanded.update(expanded => !expanded);
  }

  private getSafeNoteHtml(noteHtml: string): SafeHtml {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(noteHtml);
  }
}
